<div class="flex flex-row space-x-6 items-stretch w-full h-full">
  <div class="table-wrapper flex flex-col items-stretch basis-[500px]" cslPerfectScrollbar>
    <table class="simple panel-table">
      <thead>
        <tr>
          <th i18n>Позиция</th>
          <th i18n>Наименование</th>
          <th i18n>Размер</th>
          <th i18n>Кол-во</th>
        </tr>
      </thead>
      <tbody (keyup)="keyManager.onKeydown($event)" tabindex="0">
        <tr
          csl-focusable-element
          [item]="item"
          *ngFor="let item of panels; let i = index"
          (click)="setActive(i)"
          [ngClass]="{ selected: selectedPanel && selectedPanel.uuid === item.uuid }">
          <td>{{ item.position }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.height }}&times;{{ item.width }}</td>
          <td>{{ item.count }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div *ngIf="showProgressBar" class="progress-spinner-wrapper flex flex-col justify-center items-center flex-1">
    <mat-spinner></mat-spinner>
  </div>

  <div class="viewer flex flex-col justify-center items-center flex-1" *ngIf="!showProgressBar">
    <button
      i18n-matTooltip
      mat-icon-button
      *ngIf="!fullscreen"
      class="fullscreen-btn"
      matTooltip="Во весь экран"
      (click)="openPanelSchemaDialog()">
      <mat-icon>fullscreen</mat-icon>
    </button>

    <img [src]="curretntSchemaSafed || ''" data-testid="panels-schema-img" />
  </div>
</div>
